/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import GistEditor, { GistEditorArgs } from 'cio/components/in-app-messages-page/gist-editor';

export default class BrandingStyleEditor extends GistEditor<GistEditorArgs> {
  get editorPath() {
    return '/embed/account/branding';
  }
}
